import React, {FC} from "react";
import {useParams} from "react-router-dom";
import {useWorker} from "../../redux/workers.hook";
import {PersonHeadline} from "../../../../sharedComponents/PersonHeadline";
import {Grid} from "@material-ui/core";
import {WorkerStatusDialog} from "../../form/WorkerStatusDialog";
import {makeStyles} from "@material-ui/core/styles";
import {WorkersCheckableServices} from "./WorkersCheckableServices";
import {EditableWorkerProfile} from "./EditableWorkerProfile";

const useStyles = makeStyles((theme) => ({
    statusButton: {
        marginTop: theme.spacing(6)
    },
    card: {
        height: "100%"
    }
}));

export const WorkerScreen: FC = () => {
    const classes = useStyles();
    const {id} = useParams<{ id: string }>();
    const {worker} = useWorker(id);

    return (
        <React.Fragment>
            <PersonHeadline person={worker}/>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <EditableWorkerProfile worker={worker}/>
                </Grid>
                <Grid item xs={6}>
                    <WorkersCheckableServices
                        workerId={id}
                        servicesIds={worker?.servicesIds}
                        cardProps={{style: {height: "100%"}}}
                    />
                </Grid>
            </Grid>
            {worker && (
                <WorkerStatusDialog
                    workerId={worker.id}
                    workerName={`${worker.firstName} ${worker.lastName}`}
                    active={worker.active}
                    className={classes.statusButton}
                />
            )}
        </React.Fragment>
    );
};